import React, { useMemo, useCallback, MouseEvent } from "react";
import _ from "lodash";
import { ICellRendererParams } from "ag-grid-community";
import { getProductLink, postGotoProduct } from "helpers/legacy-cart/messaging/messaging-helper";
import { SHIPMENT_REVIEW } from "constants/integration/shipment-review";

export const ProductNameLinkRenderer = (props: ICellRendererParams) => {
    const {
        value,
        context: { brandId },
        node: { data, group, allLeafChildren },
    } = props;
    const productId = useMemo(
        () => (group ? _.head(allLeafChildren).data : data)?.fields?._product_id?.string_value,
        [allLeafChildren, data, group],
    );
    const productLink = useMemo(() => getProductLink(brandId, productId), [brandId, productId]);
    const onClick = useCallback(
        (e: MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            postGotoProduct(brandId, productId);
        },
        [brandId, productId],
    );

    return (
        <a data-test={SHIPMENT_REVIEW.NAME_LINK_VALUE} href={productLink} onClick={onClick}>
            {value}
        </a>
    );
};
